<template>
<div>
  <v-tabs class="pa-0 ma-0" v-model="tab" color="transparent" slider-color="accent" centered>
    <v-tab ripple><b>Edit</b></v-tab>
    <v-tab ripple><b>Preview</b></v-tab>
    <v-tab-item>
      <r-edit-test></r-edit-test>
    </v-tab-item>
    <v-tab-item>
      <r-test-preview></r-test-preview>
    </v-tab-item>
  </v-tabs>
</div>
</template>

<script>
import EditTest from './EditTest.vue'
import TestPreview from './TestPreview.vue'
export default {
  components: {
    rEditTest: EditTest,
    rTestPreview: TestPreview
  },
  data: () => ({
    tab: null
  })
}
</script>



// WEBPACK FOOTER //
// src/components/content/TestTask.vue